// 默认 页面 加载完成后会主动 window.scrollTo(0, 0) 配置一些不需要处理的pageId

const notScrollPageIdMap = new Map([
  ['page_car_series_pc', true], // 车型库
  ['page_series_picture_detail', true], // 图片详情
  ['page_feed_article_mix_static', true], // 资讯静态化
  ['page_ugc_detail', true], // ugc详情
  ['page_reputation_detail', true], // 口碑详情页
  ['page_topic_talk_details', true], // 话题
  ['page_series_article_list', true], // 车系文章
  ['page_series_video_list', true], // 车系视频
  ['page_car_series_dcd_score_home', true], // 车系懂车分
])

const isScroll = (pageId: string) => {
  return !pageId || !notScrollPageIdMap.get(pageId)
}

export default isScroll
